






















import Vue from 'vue';
import MpGroupField from './MpGroupField.vue';
import messageVuex from '../../vuex/common';
import ContainRelation from './ContainRelation.vue';
import customerClient from '../../../customer/apis';
import customerVuex from '../../../customer/vuex/common';
import {
  CustomerFilter,
  SubscribeSceneFilter,
  sceneItems,
  SceneItem, 
} from '../../../customer/models/CustomerFilter';

export default Vue.extend({
  mixins: [customerVuex, messageVuex],
  components: {
    MpGroupField,
    ContainRelation,
  },
  props: {
    groupIds: {
      type: Array,
      default: (): any => [],
    },
  },
  computed: {
    subscribeScenes(): SceneItem[] {
      const scenes: SceneItem[] = [];
      Object.keys(sceneItems).forEach(s => {
        scenes.push(sceneItems[s]);
      });
      return scenes;
    },
  },
  methods: {
    updateSubscribeSceneFilter(filter: SubscribeSceneFilter) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'subscribeScene',
        value: filter,
      });
    },
    updateNotIn(notIn: boolean) {
      const v = this.customerFilter.subscribeScene;
      v.notIn = notIn;
      this.updateSubscribeSceneFilter(v);
    },
    updateScenes(scenes: string[]) {
      const v = this.customerFilter.subscribeScene;
      v.scenes = scenes;
      this.updateSubscribeSceneFilter(v);
    },
  },
});
